'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;

    this.page = 1;
    this.params = {
      offset: this.page - 1,
      limit: 20,
      sortBy: 'createdAt',
      order: -1
    };
  }

  $onInit() {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page;
    }
    this.getCert();
  }

  getCert() {
    this.params.offset = (this.page - 1) * this.params.limit;
    this.$http.get('/api/DeviceCerts', {
      params: this.params
    }).then(res => {
      this.list = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/DeviceCerts/${id}`).then(res => {
        this.getCert();
      });
    }
  }

  pageChanged() {
    this.$state.go('devicecert.list', {
      page: this.page
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/devicecert/list/list.controller.js